import { Fragment } from 'react';
import { getRandomUid } from 'utilities/uuid.service';

function TextField({ labelProps = {}, inputProps = {}, fieldErrors = {} }) {
  const { label = ' TextField label', ...rest } = labelProps;
  const { id, className = '', ...props } = inputProps;

  const textFieldID = id ?? getRandomUid();

  let selectBoxClasses = '';
  const { errorMessage = '' } = fieldErrors;

  if (errorMessage) {
    selectBoxClasses = 'border border-danger';
  }

  return (
    <Fragment>
      <label htmlFor={textFieldID} {...rest}>
        {label}
      </label>
      <input
        type="text"
        placeholder="placeholder"
        id={textFieldID}
        className={`${className} ${selectBoxClasses}`}
        {...props}
      />
    </Fragment>
  );
}

export default TextField;
